import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
   name: 'datetime'
})
// depreciated by sec. 2/12/2563
export class DateTime implements PipeTransform {
   transform(type, data: any): any {
      const _text = (type === 'date') ? this.getDate(data) : this.getTime(data);
      return _text;
   }

   getDate(data) {
      let _text = '';
      switch (data.dateFormat) {
         case 0: _text = 'dd mmmm yyyy'; break;
         case 1: _text = 'dd mmm yyyy'; break;
         case 2: _text = 'dd mm yyyy'; break;
         case 3: _text = 'dd mm yy'; break;
      }
      return _text.split(' ').join(this.getSymbol(data.separateDate));
   }

   getTime(data) {
      switch (data.timeFormat) {
         case 0: return 'hh:mm';
         case 1: return 'hh:mm:ss';
         case 2: return 'hh:mm:ss.sss';
      }
   }

   getSymbol(data) {
      switch (data) {
         case 0: return '-';
         case 1: return '/';
         case 2: return ' ';
      }
   }
}
